/**
 * Mobile Network Type
 */
export enum MobileNetworkType {
  /**
   * 1G (GSM)
   */
  _1G = '1g',

  /**
   * 2G
   */
  _2G = '2g',

  /**
   * 3G
   */
  _3G = '3g',

  /**
   * 4G
   */
  _4G = '4g',

  /**
   * 5G
   */
  _5G = '5g',

  /**
   * Unspecified (Other)
   */
  Unspecified = 'unspecified',
}
